export { default } from './InfoBox';
export * from './InfoBox';
